/*
 * @Author:
 * @LastEditTime: 2024-12-30 14:17:17
 * @Description:
 */
import ContractorManagementRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'contractor-management-sm',
  title: '承包商管理',
  version: '0.1.285',
  description: '智慧安全承包商管理',
  routes: ContractorManagementRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [
      'ContractorApi',
      'AbpApplicationConfigurationApi',
      'DataCategoryApi',
      'GuidanceConfigurationDirectoryApi',
      'GuidanceConfigurationApi',
      'ContractorPersonnelApi',
      'ContractorPersonnelConfigurationApi',
      'ContractorPersonnelCertificateApi',
      'ContractorPersonnelAccessRecordApi',
      'ProfileTemplateGuidanceConfigurationApi',
      'FileApi',
      'WorkPermitApi',
      'WorkPermitGuidanceConfigurationDirectoryApi',
      'ContractorAccountRelationApi',
      'ProfileTemplateConfigurationApi',
      'ContractorEntryExitRecordsApi',
      'SpecialWorkDynamicLedgerApi',
      'SettingApi',
      'SpecialWorkDynamicLedgerApi',
      'ContractorAccountRelationApi',
      'ContractorAccountApi',
    ],
  },
  config: {
    currentEnv: {},
  },
  /**
   * init: async (store, router, config) {}
   * 异步初始化函数原型
   */
}
